import React from "react";

// Same look as the pagination on the admin pages.
export default function Pager({ page, pageSize, total, onChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const go = (p) => p >= 1 && p <= totalPages && onChange(p);
  if (total === 0) return null;
  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <p className="text-muted small mb-0">
        Showing {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total}
      </p>
      <nav aria-label="Pagination">
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => go(page - 1)}><i className="bi bi-chevron-left" /></button>
          </li>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
              <button className="page-link" onClick={() => go(p)}>{p}</button>
            </li>
          ))}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => go(page + 1)}><i className="bi bi-chevron-right" /></button>
          </li>
        </ul>
      </nav>
    </div>
  );
}